module.exports = __webpack_public_path__ + "static/media/bunu_walking.04d0c81b.png";